import DatesRange from '@/components/DatesRange.vue';
import Participants from '@/components/BountyCampaign/Participants.vue';
import Reward from '@/views/Campaign/BountyCampaign/components/Reward.vue';
import TaskProgress from './../components/TaskProgress.vue';
import ButtonJoin from './../components/Task/ButtonJoin.vue';
import TaskBody from './../components/Task/TaskBody.vue';

export default {
  props: {
    campaign: {
      type: Object,
      required: true
    },
    task: {
      type: Object,
      required: true
    },
    taskInfo: {
      type: Object
    }
  },

  head: {
    title() {
      let title = `${this.$t('metaTitle.bountyCampaign')} - ${this.$t(
        `metaTitle.${this.$route.params.name}`
      )}`;

      if (this.campaign) {
        title = `${this.campaign.title} ${title}`;
      }
      return {
        inner: title
      };
    }
  },

  components: {
    DatesRange,
    Participants,
    Reward,
    TaskProgress,
    ButtonJoin,
    TaskBody
  },

  data() {
    return {
      userJoined: false,
      userLeaved: false,
      userDenied: false,
      joinPending: false,
      joinStatePolling: null,
      participant: null
    };
  },

  computed: {
    userLeft() {
      return (
        this.userLeaved ||
        (this.participant && this.participant.status.value === 'disabled')
      );
    },
    userRejected() {
      return (
        this.userDenied ||
        (this.participant &&
          this.participant.status.value === 'disabled' &&
          !this.participant.approvedAt)
      );
    },
    rejectedReason() {
      return this.userRejected && this.participant
        ? this.participant.status.comment
        : {};
    },
    userAlreadyJoined() {
      const currentTask = this.campaign.tasks.find(
        task =>
          task.title.toLowerCase() === this.$route.params.name.toLowerCase()
      );
      return currentTask ? currentTask.joined : false;
    },
    joinBtnState() {
      return (this.userAlreadyJoined || this.userJoined) && !this.userLeaved
        ? true
        : false;
    },
    userId() {
      return this.$store.state.app.user.id;
    }
  },

  watch: {
    campaign() {
      this.$emit('updateHead');
    }
  },

  methods: {
    getIcon(type, task) {
      let icon = this.$config.taskIcons.get(`${type}--${task}`.toLowerCase());
      return icon !== undefined ? icon : 'post';
    },
    showConfirm() {
      this.$bus.$emit('modal:confirm', {
        title: this.$t('leaveTaskConfirm'),
        okHandler: () => this.leave()
      });
    },
    showReject() {
      this.$bus.$emit('modal:info', {
        title: this.$t('noCampaignAccess')
      });
    },
    tryJoin() {
      this.join();
    },
    tryLeave() {
      this.showConfirm();
    },
    leave() {
      this.$api.bounty
        .delete(`/v0/tasks/${this.task.id}/participants/${this.userId}`)
        .then(
          () => {
            this.$notify('alert', {
              text: this.$t('leaveTaskSuccess'),
              variant: 'success',
              time: 5000
            });
            this.userLeaved = true;
            this.userJoined = false;
            this.joinPending = false;
          },
          e => {
            e.response.data.detail &&
              this.$notify('alert', {
                text: e.response.data.detail,
                variant: 'danger',
                time: 5000
              });
          }
        );
    },
    join() {
      this.$api.bounty
        .post(`/v0/tasks/${this.task.id}/participants`, {
          id: this.userId
        })
        .then(
          () => {
            this.userJoined = true;
            this.userLeaved = false;
            this.joinPending = true;
            this.getParticipantStatus();
            this.pollJoinState();
          },
          e => {
            e.response.data.detail &&
              this.$notify('alert', {
                text: e.response.data.detail,
                variant: 'danger',
                time: 5000
              });
          }
        );
    },
    pollJoinState() {
      this.joinStatePolling = setTimeout(
        function poll() {
          this.$api.bounty
            .get(`/v0/tasks/${this.task.id}/participants`)
            .then(res => {
              const list = res.data;
              const currentHunter = list.find(
                participant => participant.user.id === this.userId
              );
              if (currentHunter && currentHunter.status.value !== 'pending') {
                this.joinPending = false;
                this.userJoined = currentHunter.status.value === 'enabled';
                if (!this.userJoined && !currentHunter.approvedAt) {
                  this.userDenied = true;
                  this.$bus.$emit('user-rejected', {
                    reason: currentHunter.status.comment
                  });
                }
                clearTimeout(this.joinStatePolling);
              } else {
                this.joinStatePolling = setTimeout(poll.bind(this), 10000);
              }
            });
        }.bind(this),
        10000
      );
    },
    getParticipantStatus() {
      this.$api.bounty.get(`/v0/tasks/${this.task.id}/participants`).then(
        res => {
          const userParticipantInfo = res.data.find(
            participant => participant.user.id === this.userId
          );

          if (!userParticipantInfo) return false;
          this.participant = userParticipantInfo;
          if (userParticipantInfo.status.value === 'pending') {
            this.joinPending = true;
            this.pollJoinState();
          }
        },
        e => {
          e.response.data.detail &&
            this.$notify('alert', {
              text: e.response.data.detail,
              variant: 'danger',
              time: 5000
            });
        }
      );
    }
  },

  beforeDestroy() {
    clearTimeout(this.joinStatePolling);
    this.joinStatePolling = null;
  },

  created() {
    this.getParticipantStatus();
  }
};
